import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuarioLogado, setUsuarioLogado] = useState(() => {
    const usuarioSalvo = localStorage.getItem("@usuarioLogado");

    if (usuarioSalvo) {
      return JSON.parse(usuarioSalvo);
    }

    return null;
  });

  const login = (usuario) => {
    setUsuarioLogado(usuario);
    localStorage.setItem("@usuarioLogado", JSON.stringify(usuario));
  };

  const logout = () => {
    setUsuarioLogado(null);
    localStorage.removeItem("@usuarioLogado");
  };

  return (
    <AuthContext.Provider value={{ usuarioLogado, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
